import { Injectable } from '@angular/core';

import { ConfigParserService } from './config-parser.service';

export interface MockFileInfo {
    name: string;
    size: number;
}

export interface DocumentConfig {
    mockUploadFile: MockFileInfo;
}

@Injectable({
    providedIn: 'root'
})
export class DocumentConfigService {
    private config: DocumentConfig;

    constructor(private readonly configParserService: ConfigParserService) {
    }

    public getConfig() {
        if (!this.config) {
            this.config = this.configParserService.parse<DocumentConfig>('documentConfig');
        }

        return this.config || {
            mockUploadFile: null
        };
    }
}
